module.exports = __webpack_public_path__ + "media/images/icons/twotone/control-d555d67911b0b626704658b4eb48aa17.svg";